/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { useEffect } from "react";
import { Const } from "const";
import { useInterval } from "react-use";
import { useGetAwvData } from "./GetAwvInfo";
import { useAwvDataContext } from "context/AwvDataProvider";

export const useAwvDataInterval = () => {
  const { setAwvData } = useAwvDataContext();
  const { retry, loading, value } = useGetAwvData();

  useEffect(() => {
    if (!loading && value) {
      setAwvData(value);
    }
  }, [loading, setAwvData, value]);

  useInterval(() => {
    if (!loading) {
      retry();
    }
  }, Const.awvInterval);
  return retry;
};
